import {openInModalDialog} from "./modals";

export function handleModalAnchors() {
	$('body').on('click', 'a[k1-open-modal]', function (event) {
		event.preventDefault()

		var $el = $(this)

		if (typeof $el.data('width') === 'undefined') {
			$el.data('width', '800px');
		}
		openInModalDialog($el.attr('href'), $el.data('width'));
	})

  window.runDialogAfterCallback = false;

	$('body').on('click', '[data-dismiss="modal"]', function (event) {
    var $el = $(this);
    if ($el.attr('type') === 'submit') {
      window.runDialogAfterCallback = true;
    }

		$(this).closest("[data-role=window]").data("kendoWindow").close();
	});

	$('body').on('click', 'a[k1-open-modal-special-size]', function (event) {
		event.preventDefault()

		var $el = $(this)

		if (typeof $el.data('hash') != 'undefined') {
			var newWindowTitle = $el.data('title')
			document.title = newWindowTitle

			window.history.pushState(
				{
					type: 'task',
					title: document.title
				},
				newWindowTitle,
				window.location.pathname + window.location.search + $el.data('hash')
			)
		}

		openInModalDialog($el.attr('href'), '70%', 'special-size-' + $el.data('id'));
	});
}